<ng-template #card let-c>
    <article class="kc-card">
        <div class="kc-img">
            <img [src]="'/' + c.img" [alt]="c.alt || c.name" width="150" height="150" decoding="async" />
        </div>
        <h3 class="kc-name">{{ c.name }}</h3>
        <p class="kc-desc">{{ c.desc }}</p>
    </article>
</ng-template>

<!-- more than 3 treatments: auto-scrolling slider with arrows (same behaviour as /treatments) -->
<div class="kc-wrap" *ngIf="useSlider">
    <button type="button" [class]="'kc-arrow kc-prev kc-prev-' + uid" aria-label="Previous treatments">
        <i class="fa fa-chevron-left" aria-hidden="true"></i>
    </button>

    <swiper-container #swiper init="false" class="kc-swiper">
        <swiper-slide *ngFor="let c of cards; trackBy: trackByName">
            <ng-container *ngTemplateOutlet="card; context: { $implicit: c }"></ng-container>
        </swiper-slide>
    </swiper-container>

    <button type="button" [class]="'kc-arrow kc-next kc-next-' + uid" aria-label="Next treatments">
        <i class="fa fa-chevron-right" aria-hidden="true"></i>
    </button>
</div>

<!-- 3 or fewer: plain centred cards, no slider, no arrows -->
<div class="kc-static" *ngIf="!useSlider">
    <ng-container *ngFor="let c of cards; trackBy: trackByName">
        <ng-container *ngTemplateOutlet="card; context: { $implicit: c }"></ng-container>
    </ng-container>
</div>
